export default __webpack_public_path__ + "static/media/legs.56b8a1a3.png";